import React, { Component } from "react";

import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Row } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import Statistics from "../../../../components/Statistics/StatisticsTrail/statistics";
import DataTable from "../../../../components/Tables/tables";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class TrailBank extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      loading: true
    };

    this.error = this.error.bind(this);
    this.allocateAction = this.allocateAction.bind(this);
  }

  error = response => {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  };

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    this.handleTrails();
  }

  handleTrails() {
    this.setState({ loading: true });

    axios
      .get(`${URL.api}activity/trail/public?is_partial_progression=false`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState({
          list: resp.data.data,
          loading: false
        });
      });
  }

  allocateAction = row => {
    this.props.history.push(`/trail/allocate/${row.id}`);
  };

  reportAction = row => {
    this.setState({ statisticsModal: true, selectedTrail: row.id });
  };

  printAction = row => {
    // Mock do createObjectURL para testes
    if (process.env.NODE_ENV === "test") {
      window.URL.createObjectURL = jest.fn();

      // Resetar o mock após cada teste
      afterEach(() => {
        window.URL.createObjectURL.mockReset();
      });
    }

    const downloadPath = row.file
      ? row.file.substring(row.file.indexOf("uploads/") + 8)
      : `activity/${row.file.split("/").reverse()[0]}`;

    axios
      .get(`${URL.api}download/${downloadPath}`, {
        headers: { authorization: `Bearer ${this.props.user.token}` },
        responseType: "blob"
      })
      .then(resp => {
        const fileURL =
          window.URL.createObjectURL || window.webkitURL.createObjectURL;

        if (!fileURL) {
          return;
        }

        const fileBlob = new Blob([resp.data], { type: "application/pdf" }); // ajuste o tipo MIME conforme necessário

        // Abrir o conteúdo em uma nova janela
        const printWindow = window.open(fileURL(fileBlob), "_blank");

        if (printWindow) {
          // Aguarde até que a janela seja carregada e, em seguida, imprima
          printWindow.onload = () => {
            printWindow.print();
          };
        }
      });
  };

  render() {
    return (
      <>
        {this.state.statisticsModal && (
          <Statistics
            show
            onClose={() => this.setState({ statisticsModal: false })}
            trailId={this.state.selectedTrail}
            trailName={
              this.state.list.find(item => item.id === this.state.selectedTrail)
                ?.name
            }
            currentRoute={this.props.currentRoute}
          />
        )}
        <div className="animated fadeIn">
          <Row>
            <Breadcrumb current={this.props.currentRoute} />
            {this.state.loading ? (
              <Loading top="45" left="50" />
            ) : (
              <>
                {this.state.list ? (
                  <div id="list">
                    <DataTable
                      list={this.state.list}
                      viewPath="/trail/show/"
                      title="Banco de Trilhas"
                      header={[
                        { name: "id", denomination: "ID" },
                        { name: "name", denomination: "Nome" },
                        { name: "description", denomination: "Descrição" },
                        { name: "user_name", denomination: "Usuário" }
                      ]}
                      action
                      btnView
                      btnReport
                      btnPrint
                      btnAllocate
                      printAction={this.printAction}
                      allocateAction={this.allocateAction}
                      reportAction={this.reportAction}
                    />
                  </div>
                ) : (
                  <Loading />
                )}
              </>
            )}
          </Row>
        </div>
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(TrailBank);
